import { ButtonColor, ButtonSize, ButtonWithOptions, Spinner } from "@swivl-mono/ui";
import { BlankState, MenuOption, TitleForMenuOption } from "../BotAnalyticsDashboard";
import { HandledDataForType } from "../Helpers/DataHelpers";

export const Automation = ({ nlpData, automationMenu, renderTotalsAndChart, onMenuChange, className }) => {
  let content;
  if (nlpData) {
    if (nlpData && (!nlpData.total || !nlpData.total.total)) {
      content = <div className="loadingContent ">{BlankState()}</div>;
    } else {
      const data = HandledDataForType(nlpData, automationMenu);
      let automation = "";
      if (nlpData.total.total || nlpData.total.unhandled) {
        automation = Math.round((nlpData.total.handled / (nlpData.total.handled + nlpData.total.unhandled)) * 100).toLocaleString() + "%";
      }
      content = renderTotalsAndChart(
        automation,
        nlpData.total.handled,
        nlpData.total.unhandled,
        "AUTOMATION",
        "HANDLED",
        "UNHANDLED",
        ["#00CABE", "#FF5C02"],
        automationMenu === MenuOption.TimeOfDay,
        data,
      );
    }
  } else {
    content = (
      <div className="loadingContent">
        <Spinner />
      </div>
    );
  }

  return (
    <div className={`chartBox ${className || ''}`}>
      <div className="chartHeader">
        {" "}
        <div className="chartHeaderTitle">
          {" "}
          <span>Automations by </span>
          <ButtonWithOptions
            color={ButtonColor.WHITE}
            size={ButtonSize.SMALL}
            buttonOptions={[
              { title: "Day", name: "Day", onClick: () => onMenuChange("automationMenu", "Day") },
              { title: "Time of Day", name: "TimeOfDay", onClick: () => onMenuChange("automationMenu", "TimeOfDay") },
              { title: "Day of Week", name: "DayOfWeek", onClick: () => onMenuChange("automationMenu", "DayOfWeek") },
            ]}
          >
            {TitleForMenuOption(automationMenu)}
          </ButtonWithOptions>
        </div>
        <div className="spacer" />
        <div className="chartKey">
          <div className="chartKeyItem">
            {" "}
            <span className="chartKeyBox" style={{ background: "#00CABE" }} />
            Handled
          </div>{" "}
          <div className="chartKeyItem">
            {" "}
            <span className="chartKeyBox" style={{ background: "#FF5C02" }} />
            Unhandled
          </div>
        </div>{" "}
      </div>
      <div className="chartContent">{content}</div>
    </div>
  );
}
